import { TextArea } from "components/core";
import { FormikProps } from "formik"
import { FC } from "react"

interface ApproveServiceOrderFormProps {
  form: FormikProps<{
    notes: string;
  }>;
}

export const ApproveServiceOrderForm: FC<ApproveServiceOrderFormProps> = ({ form }) => {

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Approval Information</span>
        <div className="grid gap-6 mt-2">
          <div>
            <TextArea
              id="notes"
              label="Notes"
              placeholder="e.g. Details captured are conclusive"
              required={true}
              rows={10}
              {...form}
            />
          </div>

        </div>
      </div>
    </div>
  )
}

export default ApproveServiceOrderForm